import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";

import {
  Title,
  MyAccountPageContainer,
  MyAccountContainer,
  Details,
  DetailsTitle,
  GreyContainer,
  ItemContainer,
  ItemTitle,
  ItemContent,
  ButtonContainer,
  LogoutButton,
} from "./styles";

import useLogoutModal from "containers/Header/MenuSelector/useLogoutModal";

const MyAccount: FunctionComponent = () => {
  const [cookies] = useCookies();
  const { t } = useTranslation();
  const { openLogoutModal } = useLogoutModal();

  return (
    <MyAccountPageContainer>
      <MyAccountContainer>
        <Title data-testid="my-account-title">{t("My account")}</Title>
        <Details>
          <DetailsTitle data-testid="my-details-title">{t("My details")}</DetailsTitle>
          <GreyContainer>
            {cookies.PPE_ACC_EMAIL && (
              <ItemContainer data-testid="my-mail-container">
                <ItemTitle data-testid="email-label">{t("Email address")}:</ItemTitle>
                <ItemContent data-testid="my-email">{cookies.PPE_ACC_EMAIL}</ItemContent>
              </ItemContainer>
            )}

            {(cookies.PPE_ACC_BROADBAND_ACC_ID || cookies.PPE_ACC_MSISDN) && (
              <ItemContainer data-testid="my-account-container">
                <ItemTitle data-testid="account-label">{t("Account")}:</ItemTitle>
                <ItemContent data-testid="my-account">
                  {cookies.PPE_ACC_BROADBAND_ACC_ID ? t("Broadband") : t("Mobile")}:{" "}
                  {cookies.PPE_ACC_BROADBAND_ACC_ID ? cookies.PPE_ACC_BROADBAND_ACC_ID : cookies.PPE_ACC_MSISDN}
                </ItemContent>
              </ItemContainer>
            )}
          </GreyContainer>
          <ButtonContainer>
            <LogoutButton
              id="logout-button"
              data-testid="logout-button"
              title={t("Log out")}
              onClick={openLogoutModal}
            ></LogoutButton>
          </ButtonContainer>
        </Details>
      </MyAccountContainer>
    </MyAccountPageContainer>
  );
};

export default MyAccount;
